import { useState } from 'react'
import { crud } from '@think-internet/zeus-frontend-package'
import props from '../../redux/props'
import { Analysis } from '../../types/Survey/Analysis/Analysis'

type Query = {
  surveyUUID: string
  organizationUnitUUID: OrgainizationUnitUUID
  dayNumber: DayNumber
}

type OrgainizationUnitUUID = string | { $exists: false } | { $exists: true }
type DayNumber = number | { $exists: false } | { $exists: true }

type Pull = (organizationUnitUUID: OrgainizationUnitUUID, dayNumber: DayNumber) => void

type UseListSurveyAnalysis = (surveyUUID: string) => [Analysis[], Pull]

const useListSurveyAnalysis: UseListSurveyAnalysis = (surveyUUID) => {
  const analysisFeature = crud.use(props.SURVEY_ANALYSIS)
  const [analysisList, setAnalysisList] = useState<Analysis[]>(null)

  const pull = async (organizationUnitUUID: OrgainizationUnitUUID, dayNumber: DayNumber) => {
    const query: Query = {
      surveyUUID,
      organizationUnitUUID,
      dayNumber,
    }

    const newAnalysisList: Analysis[] = await analysisFeature.list(query)
    const isNotEqualToPreviousResult =
      !Array.isArray(analysisList) ||
      analysisList.length !== newAnalysisList.length ||
      analysisList.some((analysis, index) => analysis.uuid !== newAnalysisList?.[index].uuid)
    if (isNotEqualToPreviousResult) {
      setAnalysisList(newAnalysisList)
    }
  }

  return [analysisList, pull]
}

export default useListSurveyAnalysis
